import MicroModal from 'micromodal'
init()
const body = document.body;
const openCls = 'overflow-y-hidden'

function init() {

  MicroModal.init({
    onShow: modal => handleShow(modal),
    onClose: modal => handleClose(modal),
    awaitOpenAnimation: true,
    awaitCloseAnimation: true,
    disableScroll: true,
  })
}

function handleShow(modal) {
  body.classList.add(openCls)
  document.documentElement.classList.add(openCls)
  if (modal.dataset.type === 'video') {
    console.log('video')

    handleVideoIn(modal)
  }
}
function handleClose(modal) {
  body.classList.remove(openCls)
  document.documentElement.classList.remove(openCls)
  if (modal.dataset.type === 'video') {
    handleVideoOut(modal)
  }
}

function handleVideoIn(modal) {
  const iframe = modal.querySelector('iframe')
  iframe.setAttribute('src', iframe.dataset.src)
}
function handleVideoOut(modal) {
  const iframe = modal.querySelector('iframe')
  iframe.setAttribute('src', '')
}
